import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render International award section for FAQ Page
 */
const InternationalAward = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="international-award-component"
    >
      <AccordionV2
        testId="launch"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Is this an internationally-recognised award?"
            className="px-0 font-medium"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <p className="m-0 px-6 pb-2 pt-4">
          Enterprise 50 is designed to be a local award that takes into account
          local market conditions. While the award may not yet be available
          internationally, we believe that it would be recognised
          internationally for what it is - an award for business excellence in
          the local market.
        </p>
      </AccordionV2>
    </div>
  );
};

export default InternationalAward;
